// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11AMz","content":"styles_content__13dHD"};